import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { v as bvVar } from 'bv';
import BackButtonView from './back_button_view';

const routesWithoutBack = {
  exact: [
    '/',
    '/offer',
  ],
  rest: [
    '/self_exclude',
    ...bvVar('casinoLobbies').map(({ slug }) => `/${slug}`),
  ],
};

export default () => {
  const exactMatch = useRouteMatch({
    path: routesWithoutBack.exact,
    exact: true,
  });

  const match = useRouteMatch({
    path: routesWithoutBack.rest,
  });

  if (match || exactMatch) return null;
  return <BackButtonView />;
};
